import React from "react";
import LegalPage, { Section, H2, H3, P, List } from "./components/LegalPage";
import { ANBIETER } from "./anbieter";

/* Datenschutzerklärung nach Art. 13 DSGVO.

   Jeder Abschnitt beschreibt eine Verarbeitung, die es im Code tatsächlich
   gibt — mit Zweck, Rechtsgrundlage, Empfängern und Speicherdauer. Kommt ein
   Dienst hinzu oder fällt einer weg (Backend, KI-Anbieter, Analyse), muss
   dieser Text mitgeändert werden. */

const Rechtsgrundlage = ({ children }) => (
  <P>
    <strong>Rechtsgrundlage:</strong> {children}
  </P>
);

const Speicherdauer = ({ children, last }) => (
  <P style={last === false ? undefined : { margin: 0 }}>
    <strong>Speicherdauer:</strong> {children}
  </P>
);

const Datenschutz = () => {
  return (
    <LegalPage title="Datenschutzerklärung" updated="November 2026">
      <Section>
        <H2>1. Verantwortlicher</H2>
        <P>
          Verantwortlicher im Sinne der Datenschutz-Grundverordnung (DSGVO) ist:
        </P>
        <P>
          {ANBIETER.geschaeftsbezeichnung}
          <br />
          {ANBIETER.inhaber}
          <br />
          {ANBIETER.strasse}
          <br />
          {ANBIETER.ort}, {ANBIETER.land}
          <br />
          E-Mail: {ANBIETER.email}
        </P>
        <P style={{ margin: 0 }}>
          Ein Datenschutzbeauftragter ist nicht bestellt, da die
          gesetzlichen Voraussetzungen hierfür nicht vorliegen (§ 38 BDSG).
        </P>
      </Section>

      <Section>
        <H2>2. Bereitstellung der Website und Server-Logfiles</H2>
        <P>
          Die Website wird über Firebase Hosting der Google Ireland Limited,
          Gordon House, Barrow Street, Dublin 4, Irland, ausgeliefert. Unsere
          Server-Anwendung (unter anderem für Zahlungen, Kündigungen,
          Widerrufe und den Versand von E-Mails) wird bei der Vercel Inc., USA,
          betrieben. Beim Aufruf der Website und bei Anfragen an die
          Server-Anwendung werden automatisch Daten verarbeitet, die Ihr
          Browser übermittelt: IP-Adresse, Datum und Uhrzeit des Zugriffs,
          aufgerufene Adresse, Referrer, Browsertyp und Betriebssystem.
        </P>
        <P>
          Die Verarbeitung ist erforderlich, um die Website auszuliefern sowie
          ihre Sicherheit und Stabilität zu gewährleisten.
        </P>
        <Rechtsgrundlage>
          Art. 6 Abs. 1 lit. f DSGVO. Unser berechtigtes Interesse liegt im
          sicheren und störungsfreien Betrieb der Website.
        </Rechtsgrundlage>
        <Speicherdauer>
          Logdaten werden von den Anbietern in der Regel nach spätestens 30
          Tagen gelöscht.
        </Speicherdauer>
      </Section>

      <Section>
        <H2>3. Schriftarten</H2>
        <P style={{ margin: 0 }}>
          Sämtliche Schriftarten werden von unserem eigenen Server geladen. Eine
          Verbindung zu Servern Dritter, etwa Google Fonts, findet dabei nicht
          statt.
        </P>
      </Section>

      <Section>
        <H2>4. Erstellen von Texten und Dateien</H2>
        <P>
          Die Darstellung Ihres Textes als Handschrift sowie das Erzeugen der
          PDF-, Bild- und GoodNotes-Dateien erfolgen lokal in Ihrem Browser.
          Die eingegebenen Texte werden dabei nicht an uns übermittelt und
          nicht von uns gespeichert.
        </P>
        <P style={{ margin: 0 }}>
          Zur Ermittlung der Nutzung zählen wir Seitenaufrufe, Downloads und die
          Häufigkeit der gewählten Handschriften. Gespeichert werden dabei
          ausschließlich Summen, ohne Bezug zu einer Person.
        </P>
      </Section>

      <Section>
        <H2>5. Kundenkonto und Anmeldung mit Google</H2>
        <P>
          Für das Herunterladen von Dateien und für Abonnements ist ein
          Kundenkonto erforderlich. Die Anmeldung erfolgt über Firebase
          Authentication der Google Ireland Limited mit Ihrem Google-Konto.
          Google übermittelt uns dabei Ihren Namen, Ihre E-Mail-Adresse und
          eine eindeutige Nutzerkennung. Im Kundenkonto speichern wir
          zusätzlich:
        </P>
        <List
          items={[
            "Tarif, Abonnementstatus, Laufzeitende und die Kundennummer beim Zahlungsdienstleister,",
            "das verfügbare Download-Guthaben und die in den Spielen gesammelten Münzen,",
            "bei Tarifen mit eigener Handschrift: Ihre im Browser gezeichneten Zeichen und die daraus erzeugte Schriftdatei.",
          ]}
        />
        <P>
          Die Daten werden in der Datenbank Cloud Firestore der Google Ireland
          Limited gespeichert.
        </P>
        <Rechtsgrundlage>
          Art. 6 Abs. 1 lit. b DSGVO (Durchführung des Nutzungsvertrags).
        </Rechtsgrundlage>
        <Speicherdauer>
          bis zur Löschung des Kontos (Ziffer 14).
        </Speicherdauer>
      </Section>

      <Section>
        <H2>6. Kostenlose Downloads und Missbrauchsschutz</H2>
        <P>
          Damit kostenlose Downloads und die Testphase nicht durch wiederholtes
          Anlegen und Löschen von Konten mehrfach in Anspruch genommen werden,
          speichern wir:
        </P>
        <List
          items={[
            "einen nicht umkehrbaren Hashwert Ihrer Nutzerkennung mit dem Zeitpunkt, zu dem kostenlose Downloads oder die Testphase gewährt wurden,",
            "einen mit einem geheimen Schlüssel gebildeten Hashwert Ihrer IP-Adresse beziehungsweise Ihres Netzbereichs mit der Zahl der an diesem Tag gewährten Gutschriften.",
          ]}
        />
        <P>
          Aus den Hashwerten lassen sich weder Ihre IP-Adresse noch Ihr Name
          oder Ihre E-Mail-Adresse ableiten.
        </P>
        <Rechtsgrundlage>
          Art. 6 Abs. 1 lit. f DSGVO. Unser berechtigtes Interesse liegt darin,
          unentgeltliche Leistungen vor missbräuchlicher Mehrfachnutzung zu
          schützen.
        </Rechtsgrundlage>
        <Speicherdauer>
          Der Hashwert der Nutzerkennung bleibt auch nach Löschung des Kontos
          gespeichert, da er gerade die erneute Inanspruchnahme nach einer
          Löschung verhindern soll. Die Einträge zum Netzbereich werden nach
          spätestens 30 Tagen gelöscht.
        </Speicherdauer>
      </Section>

      <Section>
        <H2>7. Bestellung und Zahlungsabwicklung</H2>
        <P>
          Zahlungen wickeln wir über die Stripe Payments Europe, Ltd., 1 Grand
          Canal Street Lower, Grand Canal Dock, Dublin, D02 H210, Irland
          (nachfolgend „Stripe“), ab. Ihre Zahlungsdaten geben Sie
          unmittelbar auf der Bezahlseite von Stripe ein; wir erhalten keine
          vollständigen Karten- oder Kontodaten. Von Stripe erhalten wir die
          Kundennummer, den Abonnementstatus, Zahlungsbeträge und -zeitpunkte.
          Stripe verarbeitet Daten zur Betrugsprävention und zur Erfüllung
          eigener gesetzlicher Pflichten auch in eigener Verantwortung; näheres
          dazu in der Datenschutzerklärung von Stripe unter
          stripe.com/de/privacy.
        </P>
        <P>
          Bei jeder Bestellung speichern wir zum Nachweis des Vertragsschlusses
          Ihre Nutzerkennung, Ihre E-Mail-Adresse, den gewählten Tarif, die
          Fassung und den Wortlaut der angezeigten Vertragshinweise, den
          Zeitpunkt der Bestellung, Ihre IP-Adresse und die Kennung Ihres
          Browsers. Die Vertragsbestätigung mit den AGB und der
          Widerrufsbelehrung senden wir Ihnen per E-Mail; für den Versand
          nutzen wir Gmail der Google Ireland Limited.
        </P>
        <Rechtsgrundlage>
          Art. 6 Abs. 1 lit. b DSGVO (Vertragsabwicklung), Art. 6 Abs. 1 lit. c
          DSGVO (steuer- und handelsrechtliche Aufbewahrungspflichten) und
          Art. 6 Abs. 1 lit. f DSGVO (Nachweis des Vertragsschlusses und der
          erteilten Informationen).
        </Rechtsgrundlage>
        <Speicherdauer>
          Abrechnungsdaten bewahren wir für die gesetzlich vorgeschriebene
          Dauer von bis zu zehn Jahren auf (§ 147 AO, § 257 HGB). Die
          Nachweisdaten zur Bestellung werden drei Jahre nach Ende des Jahres
          gelöscht, in dem der Vertrag beendet wurde (§§ 195, 199 BGB).
        </Speicherdauer>
      </Section>

      <Section>
        <H2>8. Kündigung und Widerruf</H2>
        <P>
          Wenn Sie über unsere Website kündigen oder widerrufen, verarbeiten
          wir die von Ihnen eingegebenen Angaben (E-Mail-Adresse, Name,
          Angaben zum Vertrag, Nachricht) sowie den Zeitpunkt des Eingangs.
          Zur Zuordnung gleichen wir die E-Mail-Adresse mit den Kundendaten
          bei Stripe ab. Den Eingang bestätigen wir Ihnen per E-Mail an die
          angegebene Adresse (Versand über Gmail der Google Ireland Limited).
          Widerrufserklärungen und Kündigungen, die nicht automatisch
          ausgeführt werden konnten, speichern wir zur weiteren Bearbeitung.
        </P>
        <Rechtsgrundlage>
          Art. 6 Abs. 1 lit. c DSGVO in Verbindung mit §§ 312k, 356a BGB sowie
          Art. 6 Abs. 1 lit. b DSGVO.
        </Rechtsgrundlage>
        <Speicherdauer>
          drei Jahre nach Ende des Jahres, in dem die Erklärung eingegangen ist
          (§§ 195, 199 BGB).
        </Speicherdauer>
      </Section>

      <Section>
        <H2>9. Bewertungen</H2>
        <P>
          Wenn Sie Schriftbot bewerten, speichern wir die Sternebewertung, Ihren
          optionalen Kommentar, Ihre E-Mail-Adresse, Ihre Nutzerkennung und den
          Zeitpunkt. Auf der Website veröffentlichen wir ausschließlich die
          Durchschnittsbewertung und die Anzahl der Bewertungen, nicht einzelne
          Bewertungen oder Kommentare.
        </P>
        <Rechtsgrundlage>
          Art. 6 Abs. 1 lit. f DSGVO. Unser berechtigtes Interesse liegt in der
          Verbesserung unseres Angebots.
        </Rechtsgrundlage>
        <Speicherdauer>
          bis zur Löschung des Kontos oder bis zu Ihrem Widerspruch.
        </Speicherdauer>
      </Section>

      <Section>
        <H2>10. Spiele und Ranglisten</H2>
        <P>
          In den Spielen können Sie einen Spielernamen festlegen. Ihr
          Spielername und Ihre Bestleistung werden in einer Rangliste
          gespeichert, die für alle Besucher der Website öffentlich sichtbar
          ist. Bitte wählen Sie daher einen Spielernamen, der keinen
          Rückschluss auf Ihre Person zulässt.
        </P>
        <Rechtsgrundlage>
          Art. 6 Abs. 1 lit. b DSGVO (Bereitstellung der Spiele und Ranglisten).
        </Rechtsgrundlage>
        <Speicherdauer>
          bis zur Löschung des Kontos.
        </Speicherdauer>
      </Section>

      <Section>
        <H2>11. Kontakt per E-Mail</H2>
        <P>
          Wenn Sie uns per E-Mail kontaktieren, verarbeiten wir Ihre
          E-Mail-Adresse und den Inhalt Ihrer Nachricht zur Bearbeitung Ihres
          Anliegens. Für unser E-Mail-Postfach nutzen wir Gmail der Google
          Ireland Limited.
        </P>
        <Rechtsgrundlage>
          Art. 6 Abs. 1 lit. b DSGVO, soweit Ihre Anfrage einen Vertrag
          betrifft, im Übrigen Art. 6 Abs. 1 lit. f DSGVO (Beantwortung von
          Anfragen).
        </Rechtsgrundlage>
        <Speicherdauer>
          bis zur abschließenden Bearbeitung Ihres Anliegens, soweit keine
          gesetzlichen Aufbewahrungspflichten bestehen.
        </Speicherdauer>
      </Section>

      <Section>
        <H2>12. Empfänger und Übermittlung in Drittländer</H2>
        <P>
          Wir setzen die folgenden Dienstleister ein, die Daten in unserem
          Auftrag verarbeiten (Art. 28 DSGVO):
        </P>
        <List
          items={[
            "Google Ireland Limited, Irland (Firebase Hosting, Firebase Authentication, Cloud Firestore, Google Analytics, Gmail),",
            "Vercel Inc., USA (Betrieb der Server-Anwendung).",
          ]}
        />
        <P>
          Stripe Payments Europe, Ltd. (Ziffer 7) verarbeitet Daten teilweise
          als eigener Verantwortlicher.
        </P>
        <P style={{ margin: 0 }}>
          Bei Vercel sowie bei Google und Stripe über deren
          Konzerngesellschaften in den USA können Daten in die USA übermittelt
          werden. Für die Vereinigten Staaten besteht ein Angemessenheitsbeschluss
          der Europäischen Kommission (EU-US Data Privacy Framework), soweit der
          Empfänger danach zertifiziert ist (Art. 45 DSGVO). Im Übrigen erfolgt
          die Übermittlung auf Grundlage der Standardvertragsklauseln der
          Europäischen Kommission (Art. 46 Abs. 2 lit. c DSGVO).
        </P>
      </Section>

      <Section>
        <H2>13. Cookies, lokale Speicherung und Webanalyse</H2>
        <H3>Technisch erforderliche Speicherung</H3>
        <P>
          Wir speichern Informationen auf Ihrem Endgerät oder greifen auf
          solche zu, soweit dies für den von Ihnen gewünschten Dienst
          unbedingt erforderlich ist: Ihre Anmeldung, Ihre Entscheidung zu
          Cookies, Ihre Einstellungen und einen Zwischenspeicher für Ihre
          eigene Handschrift. Hierfür ist keine Einwilligung erforderlich.
        </P>
        <Rechtsgrundlage>
          § 25 Abs. 2 Nr. 2 TDDDG; für die anschließende Verarbeitung Art. 6
          Abs. 1 lit. b und lit. f DSGVO.
        </Rechtsgrundlage>

        <H3>Google Analytics</H3>
        <P>
          Nur wenn Sie über unseren Cookie-Hinweis eingewilligt haben, setzen
          wir Google Analytics der Google Ireland Limited ein. Google Analytics
          speichert Cookies auf Ihrem Endgerät und wertet aus, wie Sie die
          Website nutzen, etwa aufgerufene Seiten, Verweildauer, Gerätetyp,
          Browser und ungefährer Standort. Ihre IP-Adresse wird dabei
          verarbeitet, nach Angaben von Google jedoch nicht gespeichert. Die
          Daten können an die Google LLC in den USA übermittelt werden; Google
          LLC ist nach dem EU-US Data Privacy Framework zertifiziert. Ohne Ihre
          Einwilligung wird Google Analytics nicht geladen.
        </P>
        <Rechtsgrundlage>
          § 25 Abs. 1 TDDDG und Art. 6 Abs. 1 lit. a DSGVO (Einwilligung).
        </Rechtsgrundlage>
        <Speicherdauer last={false}>
          Die Analysedaten werden nach spätestens 14 Monaten gelöscht.
        </Speicherdauer>
        <P style={{ margin: 0 }}>
          Ihre Einwilligung ist freiwillig. Sie können sie jederzeit mit Wirkung
          für die Zukunft widerrufen:{" "}
          <button
            type="button"
            onClick={() =>
              window.resetCookieConsent && window.resetCookieConsent()
            }
            className="sb-link"
          >
            Cookie-Einstellungen ändern
          </button>
          .
        </P>
      </Section>

      <Section>
        <H2>14. Löschung des Kontos</H2>
        <P style={{ margin: 0 }}>
          Sie können Ihr Konto jederzeit über die Funktion „Konto löschen“
          selbst löschen. Dabei werden Ihr Kundenkonto einschließlich Ihrer
          gezeichneten Handschrift und Ihr Anmeldeprofil gelöscht, und Ihr
          Kundendatensatz bei Stripe wird entfernt; ein laufendes Abonnement
          endet damit sofort. Ausgenommen sind Daten, die wir aufgrund
          gesetzlicher Aufbewahrungspflichten oder zum Nachweis nach den
          Ziffern 6, 7 und 8 weiter speichern müssen oder dürfen.
        </P>
      </Section>

      <Section>
        <H2>15. Minderjährige</H2>
        <P style={{ margin: 0 }}>
          Haben Sie das 16. Lebensjahr noch nicht vollendet, ist eine
          Einwilligung, etwa in die Webanalyse, nur wirksam, wenn Ihre Eltern
          oder anderen Erziehungsberechtigten zustimmen (Art. 8 DSGVO).
          Kostenpflichtige Verträge können Minderjährige nur mit Einwilligung
          ihrer gesetzlichen Vertreter schließen.
        </P>
      </Section>

      <Section>
        <H2>16. Ihre Rechte</H2>
        <P>Sie haben das Recht auf</P>
        <List
          items={[
            "Auskunft über die zu Ihrer Person gespeicherten Daten (Art. 15 DSGVO),",
            "Berichtigung unrichtiger Daten (Art. 16 DSGVO),",
            "Löschung Ihrer Daten (Art. 17 DSGVO),",
            "Einschränkung der Verarbeitung (Art. 18 DSGVO),",
            "Datenübertragbarkeit (Art. 20 DSGVO),",
            "Widerruf einer erteilten Einwilligung mit Wirkung für die Zukunft (Art. 7 Abs. 3 DSGVO).",
          ]}
        />
        <P>
          Zur Ausübung Ihrer Rechte genügt eine formlose Nachricht an{" "}
          {ANBIETER.email}.
        </P>

        <H3>Widerspruchsrecht nach Art. 21 DSGVO</H3>
        <P>
          Soweit wir Daten auf Grundlage von Art. 6 Abs. 1 lit. f DSGVO
          verarbeiten, haben Sie das Recht, aus Gründen, die sich aus Ihrer
          besonderen Situation ergeben, jederzeit Widerspruch gegen diese
          Verarbeitung einzulegen. Wir verarbeiten die Daten dann nicht mehr,
          es sei denn, wir können zwingende schutzwürdige Gründe für die
          Verarbeitung nachweisen, die Ihre Interessen, Rechte und Freiheiten
          überwiegen, oder die Verarbeitung dient der Geltendmachung, Ausübung
          oder Verteidigung von Rechtsansprüchen.
        </P>

        <H3>Beschwerderecht bei einer Aufsichtsbehörde</H3>
        <P style={{ margin: 0 }}>
          Sie haben das Recht, sich bei einer Datenschutz-Aufsichtsbehörde zu
          beschweren (Art. 77 DSGVO). Für uns zuständig ist die
          Landesbeauftragte für Datenschutz und Informationsfreiheit
          Nordrhein-Westfalen, Kavalleriestraße 2–4, 40213 Düsseldorf.
        </P>
      </Section>

      <Section>
        <H2>17. Weitere Hinweise</H2>
        <P>
          Die Bereitstellung Ihrer Daten ist weder gesetzlich noch vertraglich
          vorgeschrieben. Ohne Anmeldung können Sie jedoch keine Dateien
          herunterladen und kein Abonnement abschließen.
        </P>
        <P style={{ margin: 0 }}>
          Eine automatisierte Entscheidungsfindung einschließlich Profiling im
          Sinne von Art. 22 DSGVO findet nicht statt.
        </P>
      </Section>
    </LegalPage>
  );
};

export default Datenschutz;
